import logo from './logo.svg';
import './App.css';
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AccountDeletion from './screens/AccountDeletion';
import PrivacyPolicy from './screens/PrivacyPolicy';
import Contact from './screens/Contact';
import OtusProContact from './screens/OtusProContact';
import PrivacyPolicyEyeary from './screens/PrivacyPolicyEyeary';

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivacyPolicy />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />
  },
  {
    path: "/delete-account",
    element: <AccountDeletion />
  },
  {
    path: "/contact",
    element: <Contact />
  },
  {
    path: "/otus-pro-contact",
    element: <OtusProContact />
  },
    {
    path: "/eyeary-privacy-policy",
    element: <PrivacyPolicyEyeary />
  },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
